import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true, name: 'rolePipe'
})
export class RolePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'PUBLIC_USER': return 'Public User'
      case 'INTERNAL_USER': return 'Internal User'
      case 'MANAGER': return 'Manager'
      case 'ADMIN': return 'Administrator'
      case 'DASHBOARD': return 'Dashboard User'
      case 'CSR': return 'Call Center Agent'
      case 'SUPERVISOR': return 'Supervisor'
      default: return value;
    }
  }
}
